import { createFileRoute, redirect } from "@tanstack/react-router";
import { Billing } from "@/features/subscriptions";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/subscription/billing/")({
  beforeLoad: ({ location, context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["SUBSCRIPTION_VIEW", "SUBSCRIPTION_EDIT"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }

    if (!location.state.fromPrevious) {
      redirect({ to: "/subscription/overview", replace: true, throw: true });
    }
  },

  component: () => <Billing />,
});

export { Route };
